import { render, staticRenderFns } from "./EtapaDetalhar.vue?vue&type=template&id=49be0e26"
import script from "./EtapaDetalhar.vue?vue&type=script&lang=js"
export * from "./EtapaDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports